export enum AppRoutes {
  TRANSIT_TIME_FILE_FORM = 'transit-time-file-form',
  // DATA_ENTRY_PAGE = 'data-entry-page',
  NOT_AUTHORIZED_PAGE = 'not-authorized'
}
